import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import React from 'react';
import api from '../../../../../components/api';
import { VMContainerData } from '../../utils/vm-container';
import { sorter } from '../../../../../components/atoms/func';

function useModelManagementDetail() {
  // Get ModelId from param url
  const { modelId } = useParams();

  // Get All Model to get Model Name and Id for UI and Config List handler later
  const { data: modelRes, isLoading: modelLoad } = useQuery(
    ['getAllModel', 'vendingMachine'],
    () => api.vendingMachine.getAllModel(),
  );
  const modelData = React.useMemo(() => {
    const resData = modelRes?.data?.data;
    if (modelId && resData) {
      return resData.find((x) => x.id.toString() === modelId);
    }
    return undefined;
  }, [modelId, modelRes]);

  // Get Config List by Model Name
  const { data: vmConfigRes, isLoading: vmConfigLoad, refetch } = useQuery(
    ['getConfigByModel', 'vendingMachine', modelData?.model],
    () => api.vendingMachine.getConfigByModel(modelData!.model),
    { enabled: !!modelData?.model },
  );
  const vmConfigList: {id: number[], data: VMContainerData[][]} | undefined = React.useMemo(() => {
    const resData = vmConfigRes?.data?.data;
    if (resData && resData.length) {
      console.log(resData);
      const idList = resData.map((x) => x.id);
      const sortedList = resData.map((data) => data.vmTrays.map((tray) => ({
        start: tray.tray.start,
        columnCodes: tray.tray.columnCodes,
        id: tray.tray.id,
      })).sort((a, b) => sorter(a.start, b.start)));
      return {
        id: idList,
        data: sortedList,
      };
    }
    return undefined;
  }, [vmConfigRes, modelData]);

  // Navigation Handler
  const navigation = useNavigate();
  const onNavigateBack = () => navigation('/vending-machine/model-management');
  const onNavigateToAddConfig = () => navigation(`/vending-machine/model-management/add/${modelId}`);

  const { mutate: removeConfig, isLoading: removeLoad } = useMutation(api.vendingMachine.deleteModelConfiguration, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      refetch().catch((e) => console.log(e));
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });
  const handleRemove = (id: number | undefined) => {
    if (id) removeConfig(id);
  };

  return {
    vmConfig: {
      load: vmConfigLoad,
      list: vmConfigList,
    },
    vmModel: {
      data: modelData,
      load: modelLoad,
    },
    navigation: {
      back: onNavigateBack,
      add: onNavigateToAddConfig,
    },
    removeConfig: {
      handler: handleRemove,
      load: removeLoad,
    },
  };
}

export default useModelManagementDetail;
